import { makeStyles } from '@material-ui/core/styles';
const daySize = 40;
export default makeStyles(function (theme) {
  return {
    // The container element
    container: {
      display: 'inline-block'
    },
    // The wrapper element, used for keyboard interaction
    wrapper: {
      position: 'relative',
      userSelect: 'none'
    },
    // Added to the container when there's no interaction with the calendar
    interactionDisabled: {
      opacity: 0.25,
      pointerEvents: 'none'
    },
    nav: {
      height: '100%'
    },
    // The navigation bar with the arrows to switch between months
    nav_button: {
      backgroundColor: 'transparent',
      height: '100%',
      border: 'none',
      minWidth: 48,
      color: theme.palette.denim[500],
      '&:active': {
        position: 'relative',
        top: '2px'
      },
      '&[aria-disabled=true]': {
        opacity: 0.25,
        pointerEvents: 'none'
      }
    },
    nav_button_previous: {},
    // Button to switch to the previous month
    nav_button_next: {},
    // Button to switch to the next month
    navButtonInteractionDisabled: {
      color: 'red'
    },
    // Added to the navbuttons when disabled with fromMonth/toMonth props
    // Container of the months table
    months: {
      display: 'flex'
    },
    // The month's main table
    month: {
      display: 'block'
    },
    // The caption element, containing the current month's name and year
    caption: {
      alignItems: 'center',
      color: theme.palette.denim[500],
      display: 'flex',
      fontFamily: theme.typography.fontFamilyBold,
      justifyContent: 'space-between',
      height: theme.spacing(6),
      paddingLeft: theme.spacing(1.5),
      textTransform: 'uppercase'
    },
    caption_label: {},
    // Table header displaying the weekdays names
    head: {
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    vhidden: {
      display: 'none'
    },
    weeknumber: {
      color: theme.palette.denim[300],
      borderRight: `1px solid ${theme.palette.divider}`,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: `${daySize}px`,
      padding: '0 8px',
      textAlign: 'center',
      width: 20
    },
    // Cell displaying the weekday name
    weekday: {
      boxSizing: 'border-box',
      color: '#4a6271',
      fontSize: theme.typography.pxToRem(14),
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      textAlign: 'center',
      width: daySize,
      '& abbr[title]': {
        border: 'none',
        textDecoration: 'none'
      }
    },
    // Table's body with the weeks
    tbody: {},
    // Table's row for each week
    week: {
      display: 'flex'
    },
    button: {
      padding: 0
    },
    // The single day cell
    day: {
      boxSizing: 'border-box',
      background: 'none',
      border: 'none',
      color: theme.palette.denim[500],
      cursor: 'pointer',
      fontSize: theme.typography.pxToRem(14),
      height: daySize,
      lineHeight: `${daySize}px`,
      textAlign: 'center',
      transition: 'all 0.15s',
      width: daySize,
      '&:not($day_disabled):not($day_selected):not($day_outside):hover': {
        backgroundColor: theme.palette.sapphire[100]
      }
    },
    // The calendar footer (only with todayButton prop)
    tfooter: {},
    // The today button (only with todayButton prop)
    todayButton: {},
    /* default modifiers */
    // Added to the day's cell for the current day
    day_today: {},
    // Added to the day's cell specified in the "selectedDays" prop
    day_selected: {
      backgroundColor: theme.palette.sapphire[500],
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamilyBold
    },
    // Added to the day's cell specified in the "disabledDays" prop
    day_disabled: {
      color: theme.palette.text.disabled,
      cursor: 'default'
    },
    // Added to the day's cell outside the current month
    day_outside: {
      cursor: 'default'
    }
  };
}, {
  name: 'PdsDatePicker'
});